import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { BaseModule } from "./base/base.module";
import { DomainModule } from "./domain/domain.module";

export const appConfig: ApplicationConfig = {
    providers: [
      importProvidersFrom(BrowserModule, AppRoutingModule, BaseModule, DomainModule)]
  };